import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_nInput from "./gui/GUIset_nInput";

const DiceThrowProbability = () => {
	useEffect(() => {
		document.title =
			"Dice Throw Probability / Statistics of Rolling Dice: probabilities of different numbers obtained by the throw of dice";
	}, []);

	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const [inputFields, setInputFields] = useState([
		{ label: "# of Faces", text: "6" },
		{ label: "# of Dices", text: "3" },
	]);

	const handleButtonClick = (inputs) => {
		// console.log("handle" + inputs.toString());
		if (inputs[0] == "" || inputs[1] == "" || inputs[2] == "") return;
		f = parseInt(inputs[0]);
		d = parseInt(inputs[1]);
		max = f * d;
		possible_ways = Math.pow(f,d);
		//------------
		process();
		//------------
		BuildResult();
		memory = [];
	};

	var txt_time = "";
	var memory = []; // int[][]
	var possible_ways;
	var max;
	var f;
	var d;
	var s;
	var txt_result = "";

	function process() {
		Timer.start();
		// txt_result += "Sum : Frequency : Probability";
		for(var i = d; i <= max; i++){
			s = i;
			memory = T.getMatrix(f + 1, s + 1, -9999);
			var freq = findWay(d, 0);
			// txt_result += T.str_newline(txt_result) + i + " : " + freq + "/" + possible_ways + " : " + T.roundToFix(freq/possible_ways,4);
			txt_result += T.str_newline(txt_result) + i + " : " + freq  + " : " + T.roundToFix(freq/possible_ways,4);
		}
		txt_time = Timer.stop_print();
	}

	//add item from List 1 to List 2, sum of list 2 is sum
	function findWay(dices, accum) {
		if (dices == 0) return 0; //no dices left
		if (accum + dices > s) return 0; //exceed
		if (dices == 1 && accum + f >= s) return 1; //last dice & expected value
		if (memory[dices][accum] >= 0) return memory[dices][accum];
		var total = 0;
		for (var i = 1; i <= f; i++) {
			total += findWay(dices - 1, accum + i);
		}
		memory[dices][accum] = total;
		return total;
	}


	function BuildResult() {
		var txt = `Possible Sums: ${d} to ${max}\nCombinations: ${f}^${d} = ${possible_ways}`;;
		var part1 = Template.simple3size("key1", "Result", txt, txt_time, 22, 20, 17);
		var part2 = Template.simple00("key2", 1, "Sum : Frequency : Probability", txt_result, 20, 19);
		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
			</div>
		);
	}

	return (
		<GUIset_nInput
			title={"Dice Throw Probability"}
			// desc={"Statistics of Rolling Dice: the probababilities of different numbers obtained by the throw of dice. "}
			desc_v2={ <div> <b>Statistics of Rolling Dice: </b>The frequencies and probabilities  of different numbers obtained by the throw of dice. </div> }
			inputFields={inputFields}
			handleButtonClick={handleButtonClick}
			partResult={partResult}
			//
			style={1}
			n={1}
			txtButton={"Calculate"}
			width1={220}
			but_marginLeft={200}
		/>
	);
};

export default DiceThrowProbability;